import { render, staticRenderFns } from "./RoundedIcon.vue?vue&type=template&id=2665a272&scoped=true&"
import script from "./RoundedIcon.vue?vue&type=script&lang=js&"
export * from "./RoundedIcon.vue?vue&type=script&lang=js&"
import style0 from "./RoundedIcon.vue?vue&type=style&index=0&id=2665a272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2665a272",
  null
  
)

export default component.exports